import { createContext } from 'react'
import type { FilterContextType } from './type'

export const FilterContext = createContext<FilterContextType | undefined>(
    undefined
)
